const isDev = process.env.NODE_ENV !== "production";

export const logError = (message, err) => {
  if (isDev) console.error(message, err);
};
